"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variableNameToString = void 0;
const lodash_1 = require("lodash");
function variableNameToString(variableName, defaultValue = 'unknown') {
    if (!variableName || variableName === 'undefined' || typeof defaultValue !== 'string') {
        return defaultValue;
    }
    return lodash_1.startCase(variableName);
}
exports.variableNameToString = variableNameToString;
//# sourceMappingURL=variableNameToString.js.map